import { render, staticRenderFns } from "./StartupSettingsView.vue?vue&type=template&id=ef9c66e2&scoped=true"
import script from "./StartupSettingsView.vue?vue&type=script&lang=js"
export * from "./StartupSettingsView.vue?vue&type=script&lang=js"
import style0 from "./StartupSettingsView.vue?vue&type=style&index=0&id=ef9c66e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9c66e2",
  null
  
)

export default component.exports